$(document).ready(function () {
  var $readMoreWrapper = $('.js-grid-of-cards-load-more');
  $readMoreWrapper.each(function () {
    var $this = $(this);
    $this.click('button', function () {
      $this.remove();
    })
  })
  
});